import { gql } from '@apollo/client';

export const GET_HOTEL_CAPABILITES_BY_SUBDOMAIN_QUERY = gql`
  query GetHotelCapabilitesBySubdomain($subdomain: String!) {
    hotels(where: { subdomain: $subdomain }) {
      id
      roomNumberCheckIn
      roomServiceCancellation
      chatEnabled
      showLocationQrScannerInOrderFlow
      paymentValidUntil
      isExperimentalSocialMediaToolActive
      isBookitoActive
      isDailybirdActive
      enableCustomOrderandoActionCards
      getavoCode
      voucherAppCode
      isCarlitoFoodAndBeverageModuleActive
      isCarlitoShopModuleActive
      isCarlitoEvChargingModuleActive
      isBookitoOnlyMode
      isChatToEmailEnabled
    }
  }
`;
